import { render, staticRenderFns } from "./TheVisualizer.vue?vue&type=template&id=3f540e52&scoped=true"
import script from "./TheVisualizer.vue?vue&type=script&lang=js"
export * from "./TheVisualizer.vue?vue&type=script&lang=js"
import style0 from "./TheVisualizer.vue?vue&type=style&index=0&id=3f540e52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f540e52",
  null
  
)

export default component.exports